export function updateSectionDefault() {
    let lastContentBlock = document.querySelector('.section-default-inner > *:last-child')
    let firstContentBlock = document.querySelector('.section-default-inner > *:first-child')
    if (!firstContentBlock) {
        return
    }
    
    if (firstContentBlock.classList.contains('wp-block-cover') || firstContentBlock.classList.contains('is-style-visual-header')) {
        document.querySelector('.section-default').classList.add('no-padding-top')
    }
    
    if (lastContentBlock.classList.contains('has-background')) {
        document.querySelector('.section-default').classList.add('no-padding-bottom')
    }
}